import styled from "styled-components";
import {Row} from "antd";

export const CardItem = styled.div`
  display: block;
  padding: 12px;
  margin: 12px;
  border: 1px solid var(--c-line);
  background-color: #fff;
  border-radius: 4px;
  transition: all 0.2s;
  cursor: pointer;
  
  &:hover{
    background: var(--c-light-hover);
    border-color: var(--c-dark-press);
  }
`

export const StyledJournalTableContainer = styled(Row)`
  
  .ant-table-thead{
    th{
      background-color: #fafafa !important;
    }
  }
  
  .successMark:before{
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-color: var(--c-primary);
    animation-name: fadein;
    animation-duration: 7s;
    animation-fill-mode: forwards;
  }

  @keyframes fadein{
    0% { opacity:0.3; }
    50% { opacity:0.1; }
    100% { opacity:0; }
  }
`